import React, { useState, useEffect } from "react";
import { Helmet } from "react-helmet";
import Image from "react-bootstrap/Image";
import { Row, Col, Container } from "react-bootstrap";
import icon7 from "../assets/images/ic7.png";
import icon8 from "../assets/images/ic8.png";
import icon9 from "../assets/images/ic9.png";
import icon10 from "../assets/images/ic10.png";
import ManWithGreenSweaterLooksThoughtful from "../assets/images/picnic.jpg";
import award from "../assets/images/award.png";
import awardTwo from "../assets/images/award-two.png";
import LayerTwo from "../assets/images/layers/Layer_2.png";
import LayerThree from "../assets/images/layers/Layer_3.png";
import BridgingTheGAPIcon from "../assets/images/icons/BridgingTheGAP.png";
import ProvenSkillCOEFrameworkIcon from "../assets/images/icons/Proven-skill-COE-framework.png";
import AcceleratorsIcon from "../assets/images/icons/Accelerators-for-faster-time.png";
import LocalCompanyGlobalMindsetIcon from "../assets/images/icons/local-company-global-mindset.png";
import { FaLinkedin } from "react-icons/fa";
import sagarBabar from "../assets/images/Management/sagarB.png";
import BijuNambiar from "../assets/images/Management/bijuN.png";
import AniketNeurgaonkar from "../assets/images/Management/aniketN.png";
import shushilGujrathi from "../assets/images/Management/shushilG.png";
import VineetLadhania from "../assets/images/Management/VineetL.png";

import aboutBanner from "../assets/images/banner/about-banner.png";
import CSRAgenda from "../assets/images/CSR-Agenda-IMG1.webp";

import { compressImage } from "../../src/imageCompressor.js";

const About = () => {
  const [compressedImages, setCompressedImages] = useState({});
  const [bgImage, setBgImage] = useState(aboutBanner); // Initial background image

  useEffect(() => {
    const compressAllImages = async () => {
      const images = {
        icon7,
        icon8,
        icon9,
        icon10,
        ManWithGreenSweaterLooksThoughtful,
        award,
        awardTwo,
        LayerTwo,
        LayerThree,
        BridgingTheGAPIcon,
        ProvenSkillCOEFrameworkIcon,
        AcceleratorsIcon,
        LocalCompanyGlobalMindsetIcon,
        sagarBabar,
        BijuNambiar,
        AniketNeurgaonkar,
        shushilGujrathi,
        VineetLadhania,
      };

      const compressed = {};
      for (const [key, path] of Object.entries(images)) {
        try {
          compressed[key] = await compressImage(path);
        } catch (error) {
          console.error(`Error compressing ${key}:`, error);
          compressed[key] = path; // Fallback to original image
        }
      }
      setCompressedImages(compressed);

      // Compress the background image asynchronously
      try {
        const compressedBg = await compressImage(aboutBanner);
        setBgImage(compressedBg);
      } catch (error) {
        console.error("Error compressing background image:", error);
      }
    };

    compressAllImages();
  }, []);

  return (
    <>
      <Helmet>
        <title>About Comsense Technologies | AI & Salesforce Partner</title>

        <meta
          name="description"
          content="Know Comsense Technologies – a global AI & Salesforce consulting company. Experts in data, analytics, CRM & digital transformation."
        />

        <meta
          name="keywords"
          content="Comsense Technologies company, Salesforce partner India, AI consulting company Pune, Salesforce and AI partner for agentic enterprises"
        />

        <meta name="robots" content="index, follow" />
        <meta name="author" content="Comsense Technologies" />

        {/* Open Graph */}
        <meta
          property="og:title"
          content="About Comsense Technologies | AI & Salesforce Partner in Pune"
        />
        <meta
          property="og:description"
          content="Global AI & Salesforce consulting experts in data, analytics, CRM & digital transformation."
        />
        <meta property="og:type" content="website" />
        <meta
          property="og:url"
          content="https://www.comsensetechnologies.com/about"
        />

        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org/",
            "@type": "Person",
            name: "Sagar Babar",
            url: "https://www.sagarbabar.com/",
            image: "https://www.sagarbabar.com/assets/sb3-BC4-0ja_.png",
            sameAs: [
              "https://www.facebook.com/sagarbabar2040",
              "https://www.instagram.com/sagarbabar/",
              "https://www.youtube.com/@Sagarbabar_",
              "https://www.linkedin.com/in/sagarbabar/",
            ],
            jobTitle: "Chief AI Officer at Comsense Technologies",
            worksFor: {
              "@type": "Organization",
              name: "Comsense Technologies Pvt. Ltd.",
            },
          })}
        </script>
      </Helmet>
      <header
        class="masthead subPageHead data-cloud-header about-banner"
        style={{
          backgroundImage: `url(${bgImage})`,
        }}
      >
        <div class="container">
          <Row className="justify-content-start">
            <Col lg={6}>
              <p className="mb-2 text-white fw-600">About us</p>
              <h1 class="mb-0 masthead-heading fw-700 text-white fs-34">
                Bringing Excellence To Every Day At Workplace
              </h1>
            </Col>
          </Row>
        </div>
      </header>

      <section class="bg-white pt-80 pb-80">
        <Container>
          <Row className="align-items-center">
            <Col lg={5}>
              <p className="fw-400 fs-6 mb-4 ls-minus-02 text-252B42 ls-minus-064">
                When we started Comsense in 2015, our mission was clear—help
                businesses turn data into action. Too many companies were
                sitting on valuable customer insights but struggling to make
                them work.
              </p>
              <p className="fw-400 fs-6 mb-4 ls-minus-02 text-252B42 ls-minus-064">
                As ex-IBMers with deep expertise in marketing, data, and
                technology, we built Comsense into a global Martech and Data
                consulting powerhouse. Today, we specialize in Salesforce
                solutions, helping brands maximize their CRM, personalize
                customer experiences, and drive real revenue impact.​
              </p>
              <p className="fw-400 fs-6 mb-4 ls-minus-02 text-252B42 ls-minus-064">
                Fast forward to today, and we’ve grown into a global Martech and
                Data consulting company. ​We specialize in Salesforce helping
                brands unlock the full potential of their CRM, personalize
                customer experiences, and drive real revenue impact. ​
              </p>
              <p className="fw-400 fs-6 mb-0 ls-minus-02 text-252B42 ls-minus-064">
                As a Salesforce Preferred Partner, we go beyond
                implementation—we ensure businesses unlock the full potential of
                Salesforce Data Cloud, Marketing Cloud, and beyond. Our strength
                lies in bridging the gap between data and action, turning
                insights into measurable results. If you're looking to scale
                marketing, optimize customer journeys, and maximize your
                Salesforce investment, we’re here to make it happen.
              </p>
            </Col>
            <Col lg={7} className="mt-4 mt-lg-0">
              <Image
                className="w-100 rounded-4"
                src={
                  compressedImages.ManWithGreenSweaterLooksThoughtful ||
                  ManWithGreenSweaterLooksThoughtful
                }
                alt="Man With Green Sweater"
              />
            </Col>
          </Row>
        </Container>
      </section>

      <section class="page-section pt-80 pb-80 bg-EFFDFF">
        <Container>
          <Row className="align-items-center mb-5">
            <Col col={12}>
              <div class="text-center d-flex align-items-center justify-content-center">
                <h2 class="section-heading section-heading-center fw-700 fs-2">
                  Our Achievements
                </h2>
              </div>
            </Col>
          </Row>
          <Row className="align-items-center justify-content-center position-relative">
            <Col className="" lg={8}>
              <Row className="align-items-center">
                <Col lg={4} md={4}>
                  <div className="award-box mb-4 mb-lg-0 text-center">
                    <Image className="w-100" src={award} />
                    <div className="award-text">
                      <h6 className="fw-600 fs-12 ls-minus-032 mb-2">
                        Top 3 Salesforce Partner 2024
                      </h6>
                      <p className="mb-0 fw-400 fs-9 text-uppercase">
                        Salesforce 2024
                      </p>
                    </div>
                  </div>
                </Col>

                <Col lg={4} md={4}>
                  <div className="award-box mb-4 mb-lg-0 text-center">
                    <Image className="w-100" src={award} />
                    <div className="award-text">
                      <h6 className="fw-600 fs-12 ls-minus-032 mb-2">
                        Company of the Year
                      </h6>
                      <p className="mb-0 fw-400 fs-9 text-uppercase">
                        Business Leaders Awards​ 2021​
                      </p>
                    </div>
                  </div>
                </Col>
                <Col lg={4} md={4}>
                  <div className="award-box mb-4 mb-lg-0 text-center">
                    <Image className="w-100" src={award} />
                    <div className="award-text">
                      <h6 className="fw-600 fs-12 ls-minus-032 mb-2">
                        10 Indian Startup leading AI Race ​
                      </h6>
                      <p className="mb-0 fw-400 fs-9 text-uppercase">
                        Analytics India​ 2019​
                      </p>
                    </div>
                  </div>
                </Col>
              </Row>
            </Col>
            <Col lg={3} md={3} className="mt-4 mt-lg-0">
              <div className="right-award-box text-center">
                <Image width={110} className="m-auto" src={awardTwo} />
              </div>
            </Col>
          </Row>
        </Container>
      </section>

      <section class="page-section bg-blue-gradient-two position-relative z-0 pt-80 pb-80">
        <Image
          src={LayerThree}
          className="position-absolute top-0 start-0 w-40 z-n1"
        />
        <Container>
          <Row
            className="align-items-center mb-5 align-items-center justify-center"
            style={{ justifyContent: "center", textAlign: "center" }}
          >
            <Col lg={8}>
              <div class="text-center d-flex align-items-center justify-content-center position-relative">
                <h2
                  style={{ textShadow: "0px 4px 15px 0px #00000040;" }}
                  class="section-heading section-heading-center fw-700 fs-2 text-white"
                >
                  Our Unique Proposition: Winning Strategy
                </h2>
              </div>
            </Col>
          </Row>

          <Row className="align-items-stretch mt-4 position-relative">
            <Col lg={3} md={6} className="d-flex">
              <div className="mb-4 mb-lg-0 bg-E2F1FE flip-card box-shadow-three rounded-4 text-center w-100">
                <div className="front-content">
                  <Image width={45} src={BridgingTheGAPIcon} />
                  <h6 className="mt-2 text-capitalize ls-minus-032 fw-800 fs-14 mb-0">
                    Bridging the gap
                  </h6>
                </div>
                <div className="content back-content">
                  <p className="mb-0 fs-12 text-white fw-800 ls-minus-032">
                    We bring the domain knowledge, business management, and
                    technological expertise to ensure successful implementation.
                  </p>
                </div>
              </div>
            </Col>

            <Col lg={3} md={6} className="d-flex">
              <div className="mb-4 mb-lg-0  bg-E2F1FE flip-card box-shadow-three rounded-4 text-center w-100">
                <div className="front-content">
                  <Image width={45} src={ProvenSkillCOEFrameworkIcon} />
                  <h6 className="mt-2 text-capitalize ls-minus-032 fw-800 fs-14 mb-0">
                    Proven skill COE framework
                  </h6>
                </div>
                <div className="content back-content">
                  <p className="mb-0 fs-12 text-white fw-800 ls-minus-032">
                    Our proven framework delivers high-quality trained resources
                    within a shorter timeframe with industry-led certifications.
                  </p>
                </div>
              </div>
            </Col>

            <Col lg={3} md={6} className="d-flex">
              <div className="mb-4 mb-lg-0  bg-E2F1FE flip-card box-shadow-three rounded-4 text-center w-100">
                <div className="front-content">
                  <Image width={45} src={AcceleratorsIcon} />
                  <h6 className="mt-2 text-capitalize ls-minus-032 fw-800 fs-14 mb-0">
                    Accelerators for faster time to market
                  </h6>
                </div>
                <div className="content back-content">
                  <p className="mb-0 fs-12 text-white fw-800 ls-minus-032">
                    We have in-house developed accelerators that can help
                    fast-track implementations, data migration, and analytics
                    for faster time to market
                  </p>
                </div>
              </div>
            </Col>

            <Col lg={3} md={6} className="d-flex">
              <div className="mb-4 mb-lg-0  bg-E2F1FE flip-card box-shadow-three rounded-4 text-center w-100">
                <div className="front-content">
                  <Image width={45} src={LocalCompanyGlobalMindsetIcon} />
                  <h6 className="mt-2 text-capitalize ls-minus-032 fw-800 fs-14 mb-0">
                    Local company; Global mindset
                  </h6>
                </div>
                <div className="content back-content">
                  <p className="mb-0 fs-12 text-white fw-800 ls-minus-032">
                    A high-quality, ethical & knowledge-driven group of
                    individuals with enthusiasm for understanding clients'
                    businesses.
                  </p>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
        <Image
          src={LayerTwo}
          className="position-absolute bottom-0 z-n1 end-0 w-40"
        />
      </section>

      <section class="page-section pt-80 pb-80 bg-white">
        <Container>
          <Row className="align-items-center mb-5">
            <Col col={12}>
              <div class="text-center d-flex align-items-center justify-content-center">
                <h2 class="section-heading section-heading-center fw-700 fs-2">
                  Leadership
                </h2>
              </div>
            </Col>
          </Row>
          <Row className="align-items-center justify-content-center position-relative">
            <Col lg={9}>
              <Row className="justify-content-center position-relative">
                <Col className="mb-3 mb-sm-0" lg={4} md={4} sm={6}>
                  <div class="team-boxarea  ps-4 pe-4 mb-4 mb-lg-0">
                    <div class="img1">
                      <Image src={sagarBabar} className="w-100" />
                    </div>

                    <div class="content owner-content mt-3 d-flex justify-content-between align-items-top">
                      <div>
                        <h6 className="text-252B42 ls-minus-045 fw-800 fs-20 mb-1">
                          Sagar Babar
                        </h6>
                        <p className="text-252B42 fw-500 ls-minus-045 fs-13 mb-0">
                          President and Chief AI Officer
                        </p>
                      </div>
                      <ul className="list-unstyled">
                        <li className="li">
                          <a
                            href="https://www.linkedin.com/in/sagarbabar"
                            target="_blank"
                            style={{ color: "#0077B7" }}
                            className="text-0077B7" rel="noreferrer"
                          >
                            <FaLinkedin className="fs-24" />
                          </a>
                        </li>
                      </ul>
                    </div>
                  </div>
                </Col>
                <Col className="mb-3 mb-sm-0" lg={4} md={4} sm={6}>
                  <div class="team-boxarea ps-4 pe-4  mb-4 mb-lg-0">
                    <div class="img1">
                      <Image src={shushilGujrathi} className="w-100" />
                    </div>

                    <div class="content owner-content mt-3 d-flex justify-content-between align-items-top">
                      <div>
                        <h6 className="text-252B42 ls-minus-045 fw-800 fs-20 mb-1">
                          Shushil Gujrathi
                        </h6>
                        <p className="text-252B42 fw-500 ls-minus-045 fs-13 mb-0">
                          Co-founder and CEO
                        </p>
                      </div>
                      <ul className="list-unstyled">
                        <li className="li">
                          <a
                            href="https://in.linkedin.com/in/sushilgujrathi"
                            target="_blank"
                            style={{ color: "#0077B7" }}
                            className="text-0077B7" rel="noreferrer"
                          >
                            <FaLinkedin className="fs-24" />
                          </a>
                        </li>
                      </ul>
                    </div>
                  </div>
                </Col>
                <Col className="mb-3 mb-sm-0" lg={4} md={4} sm={6}>
                  <div class="team-boxarea  ps-4 pe-4  mb-4 mb-lg-0">
                    <div class="img1">
                      <Image src={BijuNambiar} className="w-100" />
                    </div>

                    <div class="content owner-content mt-3 d-flex justify-content-between align-items-top">
                      <div>
                        <h6 className="text-252B42 ls-minus-045 fw-800 fs-20 mb-1">
                          Biju Nambiar
                        </h6>
                        <p className="text-252B42 fw-500 ls-minus-045 fs-13 mb-0">
                          Co-founder & Sales Director
                        </p>
                      </div>
                      <ul className="list-unstyled">
                        <li className="li">
                          <a
                            href="https://in.linkedin.com/in/biju-nambiar-6148523"
                            target="_blank"
                            style={{ color: "#0077B7" }}
                            className="text-0077B7" rel="noreferrer"
                          >
                            <FaLinkedin className="fs-24" />
                          </a>
                        </li>
                      </ul>
                    </div>
                  </div>
                </Col>
              </Row>
              <Row className="mt-0 mt-lg-5 justify-content-center position-relative">
                <Col className="mb-3 mb-sm-0" lg={4} md={4} sm={6}>
                  <div class="team-boxarea  ps-4 pe-4  mb-4 mb-lg-0">
                    <div class="img1">
                      <Image src={VineetLadhania} className="w-100" />
                    </div>

                    <div class="content owner-content mt-3 d-flex justify-content-between align-items-top">
                      <div>
                        <h6 className="text-252B42 ls-minus-045 fw-800 fs-20 mb-1">
                          Vineet Ladhania
                        </h6>
                        <p className="text-252B42 fw-500 ls-minus-045 fs-13 mb-0">
                          Co-founder & CFO
                        </p>
                      </div>
                      <ul className="list-unstyled">
                        <li className="li">
                          <a
                            href="https://www.linkedin.com/in/vineetl/"
                            target="_blank"
                            style={{ color: "#0077B7" }}
                            className="text-0077B7" rel="noreferrer"
                          >
                            <FaLinkedin className="fs-24" />
                          </a>
                        </li>
                      </ul>
                    </div>
                  </div>
                </Col>
                <Col className="mb-3 mb-sm-0" lg={4} md={4} sm={6}>
                  <div class="team-boxarea  ps-4 pe-4  mb-4 mb-lg-0">
                    <div class="img1">
                      <Image src={AniketNeurgaonkar} className="w-100" />
                    </div>

                    <div class="content owner-content mt-3 d-flex justify-content-between align-items-top">
                      <div>
                        <h6 className="text-252B42 ls-minus-045 fw-800 fs-20 mb-1">
                          Aniket Neurgaonkar
                        </h6>
                        <p className="text-252B42 fw-500 ls-minus-045 fs-13 mb-0">
                          Co-founder & Marketing Director
                        </p>
                      </div>
                      <ul className="list-unstyled">
                        <li className="li">
                          <a
                            href="https://www.linkedin.com/in/aniket-n-0001b34/"
                            target="_blank"
                            style={{ color: "#0077B7" }}
                            className="text-0077B7" rel="noreferrer"
                          >
                            <FaLinkedin className="fs-24" />
                          </a>
                        </li>
                      </ul>
                    </div>
                  </div>
                </Col>
              </Row>
            </Col>
          </Row>
        </Container>
      </section>

      <section class="page-section bg-E2F1FE pt-70 pb-70">
        <Container>
          <Row className="align-items-center mb-5">
            <Col lg={10} className="offset-lg-1">
              <div class="text-center">
                <h2 class="section-heading text-center mb-0 section-heading-center fw-700 fs-40">
                  Corporate Social Responsibility{" "}
                </h2>
                <p className="text-252B42 ls-0 fw-500 fs-20">
                  we believe in making a positive impact on the world around us
                </p>
              </div>
            </Col>
          </Row>

          <Row className="mt-4 justify-content-center align-items-center">
            <Col lg={6}>
              <div className="ps-0 pe-lg-5">
                <h2 className="text-black ls-minus-045 fw-800 fs-26 mb-3">
                  Focus On Our CSR Agenda
                </h2>
                <p className="text-black ls-minus-045 fw-700 fs-20 mb-2 mt-4">
                  Siddheshwar Shikshan Sanstha (SSS)
                </p>

                <ul className="ps-3 red-bullets">
                  <li className="fs-14 mb-2">
                    Siddheshwar Shikshan Sanstha (SSS) is a non-profit
                    organization founded in 2008 and provides quality education
                    in English for children in rural parts of Maharashtra.
                  </li>
                  <li className="fs-14 mb-2">
                    As a first step, SSS started Dnyanankur English Medium
                    School in Alegaon, in Solapur district of Maharashtra. Today
                    over 170 students study there acquiring pre-primary
                    education, up to 5th grade. The organization also sponsors a
                    school kit (School Uniform, Shoes, Socks, School Bag, Book
                    Set, and Yearly Calendar) for every child in the school.
                  </li>
                  <li className="fs-14 mb-2">
                    The school has been one of the first to introduce
                    theme-based learning with the belief in learning through
                    real-life experience. They organize field visits such as
                    farms, zoos, bus stations, railways stations, and vegetable
                    markets fostering activity-based teaching and learning.
                  </li>
                </ul>
              </div>
            </Col>
            <Col lg={6}>
              <Image src={CSRAgenda} className="w-100 pe-0 rounded-4" />
            </Col>
          </Row>
        </Container>
      </section>

      <section class="bg-FFF pt-80 pb-5">
        <Container>
          <Row className="align-items-center mb-5">
            <Col lg={6}>
              <div class="text-left ps-0 pe-lg-5">
                <p className="text-252B42 fw-600 ls-0 mt-0 mb-2 fs-3">
                  Delivery Of Essential Food Items
                </p>
                <p className="mt-0 fs-6 fw-normal ls-0">
                  We partnered with Clara Global School to reach out to needy
                  people during the lockdown. Together, the team at Comsense and
                  members of Clara delivered 700 packets of essentials to 200
                  widows and 500 families in the Ghorpadi area of Pune.
                </p>
                <p className="mt-0 fs-6 fw-normal ls-0">
                  The area was completely sealed during the lockdown. With no
                  shops open, it was impossible to have access to essential
                  items. Our CEO & Co-founder Sagar Babar, Clara Global School’s
                  director Vishal Kawade, and volunteers joined forces to help,
                  prepare, and distribute necessary items/essentials to the
                  needy in the region.
                </p>
              </div>
            </Col>
            <Col lg="6">
              <iframe
                className="rounded-4"
                width="100%"
                height="300"
                src="https://www.youtube.com/embed/OW--rB7IjIA"
                title="In 4 Weeks: 700 packets of essentials delivered to 200 Widows &amp; 500 families."
                frameborder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                referrerpolicy="strict-origin-when-cross-origin"
                allowfullscreen
              ></iframe>
            </Col>
          </Row>
          {/* <Row className="mt-4 text-left justify-content-center">
                  <Col lg={11} md={12} className="mb-2 mb-lg-0">
                    <p className="mt-0 fs-5 fw-normal ls-0">
                      The next wave in CRM is here:{" "}
                      <span className="text-028bc6 fw-600">
                        Agent
                        <span style={{ fontStyle: "italic" }}>f</span>orce + Data 360
                      </span>
                      .
                    </p>
                    <p className="mt-0 fs-5 fw-normal ls-0">
                      Enterprises have invested heavily in{" "}
                      <span className="text-028bc6 fw-600">
                        Sales
                        <span style={{ fontStyle: "italic" }}>f</span>orce
                      </span>
                      , but fewer than 20% are truly ready for{" "}
                      <span className="text-028bc6 fw-600">AI</span>.
                    </p>
                    <p className="mt-0 fs-5 fw-normal ls-0">
                      The future of customer engagement depends on clean, connected,
                      and actionable data — powered by
                      <span className="text-028bc6 fw-600">
                        {" "}
                        Sales<span style={{ fontStyle: "italic" }}>f</span>orce Data
                        360 and Agent<span style={{ fontStyle: "italic" }}>f</span>
                        orce
                      </span>
                      .
                    </p>
                    <p className="mt-0 fs-5 fw-600 ls-0">
                      <span className="text-ee0000 fw-600">Comsense</span> helps you
                      close that readiness gap.
                    </p>
                  </Col>
                </Row> */}
        </Container>
      </section>
      <section class="bg-FFF pt-0 pb-80">
        <Container>
          <Row className="align-items-center">
            <Col lg="6" className="ps-0 pe-lg-5">
              <iframe
                className="rounded-4"
                width="100%"
                height="300"
                src="https://www.youtube.com/embed/sxisrydcg7M"
                title="Comsense Technologies &amp; Clara School teams visit Kolhapur Flood victims"
                frameborder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                referrerpolicy="strict-origin-when-cross-origin"
                allowfullscreen
              ></iframe>
            </Col>

            <Col lg={6}>
              <div class="text-left ps-0 pe-lg-5">
                <p className="text-252B42 fw-600 ls-0 mt-0 mb-2 fs-3">
                  Supporting Flood Affected Families
                </p>
                <p className="mt-0 fs-6 fw-normal ls-0">
                  Comsense team also partnered with Clara Global School towards
                  another worthy cause. Both the groups visited and distributed
                  rations to over 200 families affected by the devastating
                  Kolhapur flood. Two teams from Pune – Comsense Technologies
                  and Clara Global School were personally led by our CEO Sagar
                  Babar, ensuring that packages and food items were
                  hand-delivered to the families in dire need.
                </p>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
      <section class="page-section bg-EFFDFF pt-80 pb-80">
        <Container>
          <Row className="align-items-center mb-5">
            <Col lg={10} className="offset-lg-1">
              <div class="text-center">
                <h2 class="section-heading text-center mb-0 section-heading-center fw-700 fs-40">
                  CSR Activities
                </h2>
              </div>
            </Col>
          </Row>

          <Row className="align-items-stretch justify-content-center position-relative">
            <Col className="mb-3 d-flex" lg={3} md={6}>
              <div className="box-back rounded-1 z-0 w-100 h-100 d-flex flex-column">
                <div className="w8-bx-shadow z-1 bg-white w8-box position-relative rounded-1 ps-3 pe-3 pt-3 pb-4 d-flex flex-column flex-grow-1">
                  <h3 className="Fw-700 fs-16 fw-bold ls-0 mt-1 z-1">
                    Fund and Support a school in Alegaon – a village in
                    Maharashtra
                  </h3>
                </div>
              </div>
            </Col>
            <Col className="mb-3 d-flex" lg={3} md={6}>
              <div className="blue-box-back rounded-1  z-0 w-100 d-flex flex-column h-100">
                <div className="w8-bx-shadow z-1 bg-blue-gradient w8-box position-relative rounded-1 ps-3 pe-3 pt-3 pb-4 d-flex flex-column flex-grow-1">
                  <h3 className="Fw-700 fs-16 fw-bold ls-0 mt-1 text-white z-1">
                    Helped 200 widows and 500 families with essentials in Pune
                    during the Covid-19 outbreak and lockdown
                  </h3>
                </div>
              </div>
            </Col>
            <Col className="mb-3 d-flex" lg={3} md={6}>
              <div className="box-back rounded-1 z-0 w-100 d-flex flex-column h-100">
                <div className="w8-bx-shadow z-1 bg-white w8-box position-relative rounded-1 ps-3 pe-3 pt-3 pb-4 d-flex flex-column flex-grow-1">
                  <h3 className="Fw-700 fs-16 fw-bold ls-0 mt-1 z-1">
                    Helped more than 500 families with food packets & essentials
                    during the Kolhapur floods of 2019
                  </h3>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
};

export default About;
